import React from 'react'

const PagePaymentSection = () => (
  <div className='bg-gray-200'>
    <div className='lg:w-10/12 mx-auto py-20 sm:py-6 sm:px-4 md:py-12 md:px-8'>

      <h2 className='font-display text-gray-900 text-3xl sm:text-2xl leading-snug mb-6'>If you're a HOA resident, you can pay at:</h2>

      <div className='lg:flex block'>
        <div className='w-full pr-8 sm:pr-0'>
          <p className='text-xl text-gray-900 mb-6'>
            <a href='https://propertypay.firstcitizens.com' target='_blank' rel='noopener noreferrer' className='underline text-blue-500 hover:text-blue-900'>https://propertypay.firstcitizens.com</a>
          </p>
        </div>
      </div>

      <h2 className='font-display text-gray-900 text-3xl sm:text-2xl leading-snug mb-6'>For Commercial & Residential Tenants, you can pay at:</h2>

      <div className='lg:flex block'>
        <div className='w-full pr-8 sm:pr-0'>
          <p className='text-xl text-gray-900 mb-6'>
            <a href='https://payments.gozego.com/login/resident' target='_blank' rel='noopener noreferrer' className='underline text-blue-500 hover:text-blue-900'>https://payments.gozego.com/login/resident</a>
          </p>
        </div>
      </div>
    </div>
  </div>
)

export default PagePaymentSection